<template>
  <div class="wrap" v-if="!isLoading">
    <AfterMarket :afterMarketInfo="afterMarketInfo" />
    <OrderInfo
      :order="order"
      :images="images"
      type="aftermarket"
      :afterMarketInfo="afterMarketInfo"
    />
    <div class="footer">
      <div class="btn" @click="handleService">咨询客服</div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  computed,
  ref,
} from "@vue/composition-api";
import Vue from "vue";

import { useRoute, useStore, useRouter } from "@/components/use/base";
import { getNamespaceBenefitImage, getOrderDetail } from "@/apis";
import { getAfterMarketInfo } from "@/apis/matter";

import AfterMarket from "./AfterMarket.vue";
import OrderInfo from "@/views/MatterDetail/OrderInfo.vue";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    AfterMarket,
    OrderInfo,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const router = useRouter();

    const order = ref({});
    const images = ref([]);
    const afterMarketInfo = ref({});
    const isLoading = ref(false);

    const orderNumber = route.query.orderNumber;
    const refundNumber = route.query.refundNumber;
    const namespace = computed(() => store.state.namespace);

    onMounted(async () => {
      const loading = vm.$loading();
      isLoading.value = true;
      try {
        await fetchOrderDetail();
        await getAfterMarketDetail();
      } catch (error) {
        console.log(error);
      } finally {
        loading.close();
        isLoading.value = false;
      }
    });

    const getAfterMarketDetail = async () => {
      const { data } = await getAfterMarketInfo(refundNumber);
      afterMarketInfo.value = data;
    };

    const handleService = () => {
      router.push("/service");
    };

    const fetchOrderDetail = async () => {
      const { data: orderData } = await getOrderDetail({
        order_number: orderNumber,
      });
      const { data: imagesData } = await getNamespaceBenefitImage({
        namespace_en: namespace.value,
        product_code: orderData.type,
      });
      order.value = orderData;
      images.value = imagesData;
    };

    return {
      order,
      images,
      afterMarketInfo,
      isLoading,
      handleService,
    };
  },
});
</script>

<style lang="less" scoped>
.wrap {
  background-color: rgb(245, 245, 245);
  min-height: 100vh;
  padding: 12px;
  box-sizing: border-box;
  position: relative;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 51px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .btn {
    margin-right: 10px;
    border-radius: 17px;
    border: 1px solid #bbbbbb;
    width: 78px;
    height: 28px;

    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 28px;
    text-align: center;
  }
}
</style>
